import {
  DropdownIndicator,
  IndicatorSeparator,
  useSiteListForDropdown
} from '@nile/components';
import { AccountClient, GET_CLIENTS } from '@nile/graphql';
import { isEmpty, isString, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

function SelectField(props) {
  const { label, options, isDynamic, name } = props.attribute;

  const { value, isMulti } = props;

  const [dropdownOptions, setDropdownOptions] = useState([]);

  const [selected, setSelected] = useState('');
  const { getClientSites, data } = useSiteListForDropdown();

  useEffect(() => {
    if (data) {
      const processedSites = [];
      data.forEach((el) => {
        processedSites.push({
          label: el.name,
          value: el.name,
          id: el.id
        });
      });
      setDropdownOptions(processedSites || []);
    }
  }, [data]);

  const populateOptions = () => {
    const processedOptions = [];
    switch (props.attribute.name) {
      case 'client':
        AccountClient.query({
          query: GET_CLIENTS,
          variables: {
            listInfo: {}
          }
        }).then((res) => {
          if (res?.data?.getClientList) {
            res.data.getClientList.clients.forEach((el) => {
              processedOptions.push({
                label: el.name,
                value: el.name,
                id: el.accountId
              });
            });
          }
        });
        break;
      case 'site':
        getClientSites();
        break;
      default:
        break;
    }
    setDropdownOptions(processedOptions);
  };

  useEffect(() => {
    if (isDynamic) {
      populateOptions();
    } else {
      const processedOptions = [];
      options.forEach((option) => {
        processedOptions.push({
          label: option,
          value: option
        });
      });
      setDropdownOptions(processedOptions);
    }
  }, [options]);

  useEffect(() => {
    if (!isEmpty(value)) {
      if (isMulti) {
        const selectedOptions = [];
        const processedVal = isString(value)
          ? value.split(',').map((o) => {
              return o.trim();
            })
          : value;
        processedVal.forEach((option) => {
          selectedOptions.push({
            label: option.trim(),
            value: option.trim()
          });
        });
        setSelected(selectedOptions);
      } else {
        setSelected({
          label: value,
          value
        });
      }
    }
  }, [value]);

  const handleChange = (newValue) => {
    setSelected(newValue);
    if (isMulti) {
      props.handleChange(map(newValue, 'value'));
    } else {
      if (isDynamic) {
        switch (name) {
          case 'client':
            props.handleChange({
              accountId: newValue.id,
              name: newValue.value,
              fieldName: 'client',
              isDynamic: true
            });
            break;
          case 'site':
            props.handleChange({
              id: newValue.id,
              name: newValue.value,
              fieldName: 'site',
              isDynamic: true
            });
            break;
          default:
            break;
        }
      } else {
        props.handleChange(newValue.value);
      }
    }
  };

  return (
    <div className="w100">
      <div>{label}</div>
      <Select
        className="w100"
        classNamePrefix="value_selector"
        key={selected}
        defaultValue={selected}
        components={{ IndicatorSeparator, DropdownIndicator }}
        onChange={handleChange}
        options={dropdownOptions}
        placeholder={'Choose value'}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        closeMenuOnScroll={(e) => {
          e.stopPropagation();
          e.preventDefault();
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
        isMulti={isMulti}
      />
    </div>
  );
}

export default SelectField;
